import { createContext } from "react";

export const OrdersProvider = createContext();
